<template>
  <v-dialog
    v-model="localDialog"
    fullscreen
    scrollable
    @update:modelValue="updateDialog"
  >
    <v-card>
      <v-toolbar class="position-sticky top-0 bg-grey-lighten-4" style="z-index: 1" density="compact" color="primary">
        <v-toolbar-title>Sales Invoice</v-toolbar-title>
        <v-spacer />
        <v-btn icon="mdi-close" @click="closeDialog" />
      </v-toolbar>
  <v-container class="grey-lighten-3 full-height">
    <approval-action-sheet
        ref="approvalActionSheet"
        :approval-details="approvalDetails"
        :approval-status="saleInvoice?.approval_status"
        subject="Sales Invoice"
        @updated="refreshSaleInvoice"
    />

    <v-row class="bg-white ma-1">
      <v-col md="10">
        <v-btn
            color="primary"
            size="small"
            prepend-icon="mdi-printer"
            @click="print(0)"
        >
          Print without pad
        </v-btn>
        <v-btn
            color="primary"
            size="small"
            prepend-icon="mdi-printer"
            class="ml-2"
            @click="print(1)"
        >
          Print with pad
        </v-btn>
        <v-btn
            v-if="saleInvoice?.approval_details"
            color="yellow"
            prepend-icon="mdi-clock-alert-outline"
            class="ml-2"
            size="small"
            @click="approvalActionSheet.open()"
        >
          Approval History
        </v-btn>
      </v-col>
      <v-col style="display: flex; justify-content: end" md="2">
        <v-btn
            color="primary"
            size="small"
            variant="tonal"
            prepend-icon="mdi-reload"
            @click="refreshSaleInvoice()"
        >
          Refresh
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img
              v-if="saleInvoice?.branch?.company?.watermark && invoiceHeader"
              :src="fileServerUrl + saleInvoice?.branch?.company?.watermark"
              alt=""
              style="height: 400px!important"
            >
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <!-- <tr v-if="saleInvoice?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${saleInvoice?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr> -->

                  <tr v-if="invoiceHeader">
                    <td colspan="100%">
                      <div>
                        <div style="display: flex; justify-content: flex-end; align-items: flex-start; padding-bottom: 10px; margin-bottom: 16px;">
                          <img
                            :src="`${getFileServerUrl}${saleInvoice?.branch?.company?.logo}`"
                            class="logo-img"
                            alt="Logo"
                            style="max-height: 80px;"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </thead>

                <tbody>

                  <!-- Invoice Details Section -->
                  <tr>
                    <td colspan="100%">
                      <div class="header-table" style="font-size: 12px; margin-top: 10px;">

                        <div style="display: flex; justify-content: center;">
                          <h1 style="font-size: 16px; text-decoration: underline;">Invoice / Bill</h1>
                        </div>
                        <div style="display: flex; justify-content: space-between; margin-bottom: 10px">
                          <div>
                            <div>
                              Bill To, <br>
                              <strong>{{ saleInvoice?.customer?.company_name }}</strong><br/>
                              <strong>{{ saleInvoice?.delivery_address}}</strong><br>
                            </div>

                            <div>
                              <template v-if="saleInvoice?.customer?.contacts?.[0]">
                                <p><strong>Attention:</strong> {{ saleInvoice?.customer?.contacts?.[0]?.name }}</p>
                                <p><strong>Contact no:</strong> {{ saleInvoice?.customer?.contacts?.[0]?.mobile }}</p>
                              </template>
                            </div>
                          </div>
                          <div>
                            <p><strong>Invoice No:</strong> {{ saleInvoice?.code }}</p>
                            <p><strong>Invoice Date:</strong> {{ formatDateView(saleInvoice?.sale_invoice_date) }}</p>
                            <p><strong>Po Date:</strong> {{ saleInvoice?.po_date }}</p>
                            <p><strong>Challan Date:</strong> {{ formatDateView(saleInvoice?.sale_invoice_delivery?.invoice_delivery_date) }}</p>
                            <p><strong>PO/Ref No:</strong> {{ saleInvoice?.po_no }}</p>
                            <p><strong>Challan No:</strong> {{ saleInvoice?.sale_invoice_delivery?.code }}</p>
                          </div>
                        </div>

                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                        <tr>
                          <th style="display:flex; justify-content: start; margin-bottom: 4px; border:none; padding: 3px">
                            Item Details
                          </th>
                        </tr>
                        </thead>
                      </table>
                    </td>
                  </tr>

                  <!-- Details table -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">SN</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Code</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Product Name & Grade</th>
                              <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Unit</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Lot No.</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Qty.</th>
                            <th v-if="isFreeItem" style="border: 1px solid black; padding: 2px; font-size: 12px;">Free Qty.</th>

                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Rate</th>
                            <th style="border: 1px solid black; padding: 2px; font-size: 12px;">Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                            <template v-for="(row, idx) in saleInvoice?.details" :key="idx">

                          <tr>
                            <td style="border: 1px solid black; padding: 2px; text-align: center;">{{ idx + 1 }}</td>
                            <td style="border: 1px solid black; padding: 2px; text-align: center;">{{ row.product?.code }}</td>
                            <td style="border: 1px solid black; padding: 2px; text-align: left;">{{ row.product?.name }} {{ row?.remarks && (`/ ${row.remarks}`) }}</td>
                             <td style="border: 1px solid black; padding: 2px; text-align: center;">{{ row.product?.unit?.name }}</td>
                            <td style="border: 1px solid black; padding: 2px; text-align: center;">{{ row.lot_no }}</td>
                            <td style="border: 1px solid black; padding: 2px; text-align: right;">{{ $numberFormat(row.qty) }}</td>
                            <td v-if="isFreeItem" style="border: 1px solid black; padding: 2px; text-align: right;">{{ $numberFormat(row.free_qty) }}</td>

                            <td style="border: 1px solid black; padding: 2px; text-align: right;">{{ $numberFormat(row.sale_rate) }}</td>
                            <td style="border: 1px solid black; padding: 2px; text-align: right;">{{ $numberFormat(row.total) }}</td>
                          </tr>

                             <!-- 🎁 Gift Rows -->
                                <tr v-for="(gift, gIdx) in row.gifts || []"
                                    :key="'gift-'+idx+'-'+gIdx">

                                  <td style="border:1px solid black; text-align:center;"></td>

                                 <td style="border:1px solid black; text-align:center;">{{ gift.product?.code }}</td>

                                  <td style="border:1px solid black; text-align:left;">
                                    🎁 {{ gift.product?.name }}
                                  </td>

                                  <td style="border:1px solid black; text-align:center;"></td>

                                  <td style="border:1px solid black; text-align:center;">
                                    {{ gift.product?.unit?.name }}
                                  </td>

                                  <td style="border:1px solid black; text-align:center;">
                                    {{ $numberFormat(gift.qty) }}
                                  </td>

                                  <td style="border:1px solid black; text-align:right;">{{ $numberFormat(0) }}</td>

                                  <td style="border:1px solid black; text-align:right;">{{ $numberFormat(gift.sale_rate) }}</td>

                                  <td style="border:1px solid black; text-align:right;">{{ $numberFormat(gift.total) }}</td>

                                </tr>


                          </template>

                        </tbody>
                        <tfoot>
                            <tr>
                            <td colspan="100%" style="border: none; padding: 0">
                              <table style="width: 100%; border-collapse: collapse; font-size: 12px;text-align: end; margin-top: 0px !important;">
                                <tbody>
                                  <tr>
                                    <td style="border: 1px solid black; padding: 2px; width: 87%; border-top: none !important;"><strong>SUBTOTAL</strong></td>
                                    <td style="border: 1px solid black; padding: 2px; text-align: right; border-top: none !important;">{{ $numberFormat(saleInvoice?.sub_total) }}</td>
                                  </tr>
                                  <tr v-if="saleInvoice?.discount_amount > 0">
                                    <td style="border: 1px solid black; padding: 2px;"><strong>DISCOUNT</strong></td>
                                    <td style="border: 1px solid black; padding: 2px; text-align: right;">{{ $numberFormat(saleInvoice?.discount_amount) }}</td>
                                  </tr>
                                  <tr v-if="orderInvoice?.vat_amount >0">
                                    <td style="border: 1px solid black; padding: 2px; text-transform: capitalize;"><strong>VAT ({{ saleInvoice?.vat_type }})</strong></td>
                                    <td style="border: 1px solid black; padding: 2px; text-align: right;">{{ $numberFormat(saleInvoice?.vat_amount) }}</td>
                                  </tr>
                                  <tr v-if="saleInvoice?.tax_amount > 0">
                                    <td style="border: 1px solid black; padding: 2px; text-transform: capitalize;"><strong>TAX ({{ saleInvoice?.tax_type }})</strong></td>
                                    <td style="border: 1px solid black; padding: 2px; text-align: right;">{{ $numberFormat(saleInvoice?.tax_amount) }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border: 1px solid black; padding: 2px;"><strong>PAID</strong></td>
                                    <td style="border: 1px solid black; padding: 2px; text-align: right;">{{ $numberFormat(Number(saleInvoice?.sub_total) - Number(saleInvoice?.due)) }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border: 1px solid black; padding: 2px;"><strong>DUE</strong></td>
                                    <td style="border: 1px solid black; padding: 2px; text-align: right;">{{ $numberFormat(saleInvoice?.due) }}</td>
                                  </tr>
                                  <tr style="background-color: #f0f0f0;">
                                    <td style="border: 1px solid black; padding: 2px; font-weight: bold;"><strong>TOTAL</strong></td>
                                    <td style="border: 1px solid black; padding: 2px; text-align: right; font-weight: bold;">{{ $numberFormat(saleInvoice?.total) }}</td>
                                  </tr>
                                </tbody>
                              </table>

                              <div style="font-size: 12px; display: flex; margin-top: 20px;">
                                <p style="text-align: start;"><strong>Amount in Words:</strong></p>
                                <p style="text-align: start; margin-left: 4px; font-style: italic"><strong> {{ convertNumberToWords(saleInvoice?.sub_total) }}</strong></p>
                              </div>

<!--                              <div style="font-size: 12px; display: flex; margin-top: 5px;">-->
<!--                                <p style="text-align: start;"><strong>Mode of payment: </strong></p>-->
<!--                                <p style="text-align: start;"> by A/C payee cheque in favour of "{{ saleInvoice?.branch?.company?.name }}"</p>-->
<!--                              </div>-->

<!--                              <div style="font-size: 12px; margin-top: 5px; background-color: #ffffff;">-->
<!--                                <p><strong>Payment Terms: </strong></p>-->
<!--                                <p>{{ saleInvoice?.sale_order?.payment_terms || '-' }}</p>-->
<!--                              </div>-->
                              <div style="font-size: 12px; padding-top: 10px; background-color: #ffffff;">
                                <div style="margin-left: 20px" v-html="saleInvoice?.remarks"></div>
                              </div>

                              <div v-if="saleInvoice?.payment_bank" style="font-size: 12px; margin-top: 5px; background-color: #ffffff;">
                                <p><strong>Bank Payment Details: </strong></p>
                                <table style="border-collapse: collapse;">
                                  <tbody >
                                  <tr>
                                    <td style="border:none; width: 200px;">Account Name</td>
                                    <td style="border:none;">:{{  saleInvoice?.payment_bank?.account_name? `${saleInvoice?.payment_bank?.account_name}`: ""  }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border:none;">Account Number</td>
                                    <td style="border:none;">:{{ saleInvoice?.payment_bank?.account_no? `${saleInvoice?.payment_bank?.account_no}`: ""  }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border:none;">Name of the Bank</td>
                                    <td style="border:none;">:{{ saleInvoice?.payment_bank?.name? `${saleInvoice?.payment_bank?.name}`: ""  }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border:none;">Branch Name</td>
                                    <td style="border:none;">:{{ saleInvoice?.payment_bank?.branch? `${saleInvoice?.payment_bank?.branch}`: ""  }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border:none;">Swift Code</td>
                                    <td style="border:none;">:{{ saleInvoice?.payment_bank?.swift_code? `${saleInvoice?.payment_bank?.swift_code}`: ""  }}</td>
                                  </tr>
                                  <tr>
                                    <td style="border:none;">Routing No.</td>
                                    <td style="border:none;">:{{ saleInvoice?.payment_bank?.routing_no? `${saleInvoice?.payment_bank?.routing_no}`: ""  }}</td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>

                            </td>
                          </tr>
                        </tfoot>
                      </table>
                    </td>
                  </tr>

                  <!-- Signatures -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div style="margin-top: 10px; ">
                        <v-row style="display: flex; justify-content: space-between">
                          <v-col cols="4" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 12px;">Prepared & Issued By</div>
                            </div>
                          </v-col>
                          <v-col cols="4" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 12px;">Authorized Signatory</div>
                            </div>
                          </v-col>
                          <v-col cols="4" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 12px;">Received & Accepted By</div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot v-if="invoiceHeader">
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <!-- <img v-if="saleInvoice?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${saleInvoice?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;"> -->
              <div class="invoice-footer" v-if="invoiceHeader" style="margin-left:10px; margin-bottom:10px; color: #343591;">
                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M12 11.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7" />
                  </svg>

                  <span>{{ saleInvoice?.branch?.company?.address }}</span>
                </p>

                <p style="font-size: 13px; font-weight: 500; display: flex; align-items: center; gap:4px">
                  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path fill="currentColor" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z" />
                  </svg>

                  <strong>Phone: </strong>  +880 9610-993393, +880 2 222288648, www.remexingredient.com | www.remexcorp.com
                </p>
              </div>
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

  </v-container>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { onMounted, ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import convertNumberToWords from "@/plugins/numberToWord";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import { getCompanyInfo } from '@/plugins/helpers'
import { fileServerUrl } from "@/store/api";
import ApprovalActionSheet from "@/components/utils/approvalActionSheet.vue";

const route = useRoute();
const store = useStore();
const props = defineProps({
  dialog: {
    type: Boolean,
    default: false,
  },
  invoiceId: {
    type: [String, Number],
    default: null,
  },
});
const emit = defineEmits(["update:dialog"]);
const localDialog = ref(props.dialog);
watch(() => props.dialog, (value) => {
  localDialog.value = value;
});
watch(localDialog, (value) => {
  emit("update:dialog", value);
});
const updateDialog = (value) => {
  emit("update:dialog", value);
};
const closeDialog = () => {
  emit("update:dialog", false);
};

const saleInvoice = ref();
const pagePadding = ref(0);
const invoiceHeader = ref(true);
const isGiftItem = ref(false);
const isFreeItem = ref(false);
const approvalActionSheet = ref(null);

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);
const approvalDetails = computed(() => saleInvoice.value?.approval_details || {});

const loadSaleInvoice = async () => {
  const id = props.invoiceId || route.params.id;
  saleInvoice.value = await store.dispatch('getSaleInvoiceById', id);
};

const refreshSaleInvoice = async () => {
  await loadSaleInvoice();
};

const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Invoice</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        @page {
          size: A4;
          margin: ${pagePadding.value}px 0;
        }

        html, body {
          margin: 0 ;
          padding: 0;
          width: 100%;
          height: auto;
        }

        body {
          font-family: sans-serif;
          background:#fff;
          color:#000;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }

        .report-paper {
          width: 100%;
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }

        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .header-table {
          padding: 0 32px;
        }

        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }

        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }

        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }

        .details-table {
          padding: 0px 32px;
        }

        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }

        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }

        .header-section {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          border-bottom: 2px solid #eee;
          padding-bottom: 10px;
          margin-bottom: 16px;
        }

        .company-name {
          font-size: 12px;
          font-weight: bold;
          text-transform: uppercase;
          margin: 0 0 4px 0;
        }

        .company-text {
          font-size: 12px;
          margin: 2px 0;
          display: flex;
          align-items: center;
        }

        .logo-container img {
          max-height: 70px;
          max-width: 150px;
        }

        .report-title {
          font-size: 16px;
          text-align: center;
          margin: 8px 0;
        }

        .watermark {
          position: fixed;
          transform: translate(143%, 170%);
          z-index: 0;
        }

        table {
          width: 100% !important;
          border-collapse: collapse;
          font-size: 12px;
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        th, td {
          border: none;
          padding: 0;
          vertical-align: middle;
        }

        th {
          background: #e0e0e0;
          text-align: center;
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .master-box-parent {
          border: none !important;
          //page-break-inside: avoid;
        }

        .master-box {
          margin: 16px 0;
          //page-break-inside: avoid;
        }

        .invoice-content {
          //page-break-inside: avoid;
        }

        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }

        table {
          //page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }

        tr {
          //page-break-inside: avoid;
        }
        .mt-4 {
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 {
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }

        img {
          max-width: 100% !important;
          height: auto !important;
        }

        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }

        /* FIXED: Replace Vuetify v-row/v-col with plain flex for print */
        .v-row {
          display: flex !important;
          flex-wrap: wrap !important;
          margin: 0;
          width: 100%;
        }

        .v-col-6 {
          flex: 0 0 50% !important;
          max-width: 50% !important;
          padding: 0 12px 12px 12px;
          box-sizing: border-box;
          margin: 0;
        }

        .pa-6 { padding: 0 !important; }

        .order-table thead {
          display: table-header-group;
          //page-break-inside: avoid;
        }

        .order-table tbody {
          //page-break-inside: avoid;
        }

        div[style*="margin-top"], div[style*="padding"] {
          //page-break-inside: avoid;
        }

        .order-table tbody tr {
          //page-break-inside: avoid;
        }

        .signature-box {
          font-size: 12px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }

        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }

        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 12px;
        }

        .invoice-container {
          display: flex;
          flex-direction: column;
        }

        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }

        .company-info {
          flex: 1;
        }

        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left: 0;
          bottom: 0px;
          width: 100%;
        }

        @media print {
          body {
            margin: 0;
            padding: 0;
          }

          .report-paper {
            margin: 0;
            padding: 0;
          }

          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }

          .order-table {
            page-break-inside: auto;
          }

          .order-table tr {
            //page-break-inside: avoid;
            page-break-after: auto;
          }

          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

onMounted(async () => {
  await loadSaleInvoice();
  isGiftItem.value = getCompanyInfo()?.is_gift_item ?? false;
  isFreeItem.value = getCompanyInfo()?.is_free_item ?? false;
})
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 12px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 12px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 12px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 12px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>